import MobileProfileTopNavigation from './MobileProfileTopNavigation';
import PersonalDetailsSection from '../../PageComponent/ProfilePage/PersonalDetailsSection';

function MobilePersonalDetails() {
  return (
    <div className="text-coalBlack pt-12">
      <MobileProfileTopNavigation pageTitle={'Personal Details'} />
      <PersonalDetailsSection />
    </div>
  );
}

export default MobilePersonalDetails;
